import React, { useEffect, useState } from "react";
import { getAllActive } from "../../../Infrastructure/Services/DataService";
import { getWithExpiry } from "../../../Domain/Helpers/LocalStorageHelper";
import { formatArrayForSelectInput } from "../../../Domain/Helpers/SelectInputHelper";
import { inputType } from "../../../Domain/Constants/InputType";
import GenericInsertUpdatePage from "../../../Domain/Components/Functional/GenericInsertPage/GenericInsertPage";
import { toast } from "react-toastify";

function OperatorTenantInsertPage(props) {
    const [operator, setOperator] = useState(null);
    const [tenant, setTenant] = useState(null);
    const [inputs, setInputs] = useState([]);

    useEffect(() => {
        const token = getWithExpiry("token");

        if (token === null) {
            props.setLoggedIn(false);
            return;
        }

        getAllActive("tenant/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available tenants");
            } else {
                setTenant(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });

        getAllActive("operator/read", token).then((data) => {
            if (data === null) {
                toast.error("Failed to load the available operators");
            } else {
                setOperator(data);
            }
        }).catch((ex) => {
            toast.error(ex);
        });
    }, []);

    useEffect(() => {
        if (operator && tenant) {
            setInputs([
                {
                    inputType: inputType.SELECT,
                    labelText: "Tenant",
                    required: true,
                    inputId: "tenant_id",
                    validationFunction: () => {return null},
                    selectOptions: formatArrayForSelectInput(tenant, "external_id")
                },
                {
                    inputType: inputType.SELECT,
                    labelText: "Operator",
                    required: true,
                    inputId: "operator_id",
                    validationFunction: () => {return null},
                    selectOptions: formatArrayForSelectInput(operator, "company_name")
                }
            ])
        }
    }, [tenant, operator])

    return (
        <GenericInsertUpdatePage inputs={inputs}
            setLoggedIn={props.setLoggedIn}
            endpoint={"operator-tenant/create"}
            pageTitle={"Update Operator Tenant"}
            isUpdate={false}
            getEndpoint={"operator-tenant/read"}
            entityName={"Operator Tenant"} />
    )
}

export default OperatorTenantInsertPage;